import { useEffect, useLayoutEffect, useRef } from "react"
import styled from "@emotion/styled"

import { useViewport } from "contexts/Viewport"

import { useErsive } from "./context"

const Can = styled.canvas`
  width: 100%;
  height: 100%;
  object-fit: cover;

  transform: translate3d(0, 0, 0) scale(1.002);
`

export default function Canvas({ }) {
  const { canCtx, sources } = useErsive()
  const viewport = useViewport()
  const ref = useRef()

  useLayoutEffect(() => {
    const o = viewport.orientation.get()
    canCtx.current = ref.current.getContext("2d")
    ref.current.width = sources.get(o).width
    ref.current.height = sources.get(o).height
  }, [])

  function onOrientChange(o) {
    ref.current.width = sources.get(o).width
    ref.current.height = sources.get(o).height
  }
  useEffect(() => viewport.orientation.onChange(onOrientChange))

  return <Can ref={ref} />
}

/*
export default function Canvas({}) {
  const { canCtx, sources } = useErsive()
  const viewport = useViewport()
  const ref = useRef()

  useLayoutEffect(() => {
    const o = viewport.isMobile.get() ? "portrait" : "landscape"
    canCtx.current = ref.current.getContext("2d")
    ref.current.width = sources.get(o).width
    ref.current.height = sources.get(o).height
  }, [])

  function onOrientChange(bool) {
    const o = bool ? "portrait" : "landscape"
    ref.current.width = sources.get(o).width
    ref.current.height = sources.get(o).height
  }
  useEffect(() => viewport.isMobile.onChange(onOrientChange))

  return <Can ref={ref} />
}
*/